import React from 'react';
import { Course } from '../../interfaces/course';

// 2. Define the props for the CourseTitle component
interface CourseTitleProps {
    course: Course;
}

/**
 * Displays a course code and name as a link to the course page.
 */
const CourseTitle: React.FC<CourseTitleProps> = ({ course }) => {
    const displayText = `[${course.course_code}] ${course.course_name}`;

    return (
        <a
            className="mr-10"
            href={`/course/${course.course_id}`}
            title={`View details for course ${displayText}`}
        >
            {displayText}
        </a>
    );
};

export default CourseTitle;
